module.exports = __webpack_public_path__ + "img/arrow.6a2d6a1a.svg";